import React, { CSSProperties } from 'react';
import Spiner from 'app/assets/Spinner_Loading.svg';
import styles from './LoadingSpiner.module.scss';

interface LoadingSpinnerProps {
  containerStyle?: CSSProperties;
  imageStyle?: CSSProperties;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  containerStyle,
  imageStyle
}) => {
  return (
    <div className={styles['spinner-background']} style={containerStyle}>
      <img
        src={Spiner}
        alt="loading"
        className={styles.spinner}
        style={imageStyle}
      />
    </div>
  );
};
